<template>
  <div class="contactUs">
    <div class="contactGrid">
      <div class="contactInfoCol">
        <div class="contactInfo">
          <h4 v-scroll-reveal="LeftReveal1">Contact Us</h4>
          <h2 v-scroll-reveal="LeftReveal2">We look forward to hearing from you.</h2>
          <div>
            <div class="details">
              <div class="hoursDetails" v-scroll-reveal="bottomReveal1">
                <article>Phone Number</article>
                <p style="margin-bottom: 15px">
                  <a href="tel: 000-000-0000">
                    <u>Ph. (662) 652 1700</u>
                  </a>
                </p>
                <article>Last Minute Reservations</article>
                <p>
                  For the last minute reservation inquiry or following up,
                  please send email to
                  <a href="mailto: reservation@eatatgaggan.com">
                    <u>reservation@eatatgaggan.com</u>
                  </a>
                </p>
              </div>
              <div class="hoursDetails" v-scroll-reveal="bottomReveal2">
                <article>Monday to Saturday</article>
                <p>1st round 5:30 pm</p>
                <p style="margin-bottom: 15px">2nd round 9:30 pm</p>
                <article>Press Release</article>
                <p>For PR inquiry, please send email to <a href="mailto: pr@eatatgaggan.com">
                    <u>pr@eatatgaggan.com</u></a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mapContainer">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15502.732942617315!2d100.5421671!3d13.7376179!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9aa2e09453d8f871!2sGaggan!5e0!3m2!1sen!2sus!4v1564192790278!5m2!1sen!2sus" frameborder="0" allowfullscreen></iframe>
      </div>
      </div>

    <div class="ourLocationBox"></div>
  </div>
</template>

<script>
import nextPage from "../components/nextPage.vue";
import VueScrollReveal from "vue-scroll-reveal";

export default {
  name: "contactUs",
  components: {
    nextPage
  },
  data() {
    return {
      LeftReveal1: {
        duration: 1000,
        delay: 400,
        distance: "20px",
        origin: "left"
      },
      LeftReveal2: {
        duration: 1000,
        delay: 600,
        distance: "20px",
        origin: "right"
      },
      bottomReveal1: {
        duration: 1000,
        delay: 1200,
        distance: "20px",
        origin: "left"
      },
      bottomReveal2: {
        duration: 1000,
        delay: 1600,
        distance: "20px",
        origin: "right"
      },
    }
  }
};
</script>

<style src="../styles/main.scss" lang="scss">
</style>